import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-white/50 backdrop-blur-sm border-t border-slate-200 py-6 mt-auto">
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <div className="flex items-center gap-2 text-green-600 mb-2 bg-green-50 px-4 py-2 rounded-full border border-green-100">
          <SafeIcon name="Shield" className="w-4 h-4" />
          <span className="text-sm font-medium">Local browser processing</span>
        </div>
        <p className="text-slate-500 text-sm max-w-xl">
          <strong>Privacy Statement:</strong> Your files are processed locally in your browser. Nothing is uploaded or stored on a server. Image, favicon and QR processing happens on this device.
        </p>
      </div>
    </footer>
  );
};

export default Footer;